export default __webpack_public_path__ + "images/0xff191514a9baba76bfd19e3943a4d37e8ec9a111.png";